import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';
import { mapReferencePrice, RawReferencePrice } from '~/Api/User/ProductGroup/LtMaxPrice/mapReferencePrice';
import { Product } from '~/Api/User/ProductGroup/LtMaxPrice/Product';

export interface RawProduct {
	allowsEmptyCalculator: { exFactory: boolean };
	packageSizeForCalculation: number | null;
	packageSizeForSingleUnit: number | null;
	dosageStrengthForCalculation: number | null;
	product: RawGeneralProduct;
	referenceDataSource: boolean;
	referencePrices: RawReferencePrice[];
	selectable: boolean;
	selected: boolean;
	singleUnitPackageSize: boolean;
}

export const mapProduct = (product: RawProduct): Product => {
	return new Product(
		product.allowsEmptyCalculator,
		product.packageSizeForCalculation,
		product.packageSizeForSingleUnit,
		product.dosageStrengthForCalculation,
		mapGeneralProduct(product.product),
		product.referenceDataSource,
		product.referencePrices.map(mapReferencePrice),
		product.selectable,
		product.selected,
		product.singleUnitPackageSize
	);
};
